import React from 'react';
import { Autocomplete, Box, Divider, TextField, Typography, Tooltip, Button } from '@mui/material';
import TableData from '../../custom/Table/TableData';
import CellType from '../../../constants/type';
import useI18n from '../../../hooks/useI18n';
//import fakeData from './fakeData.json';
import Search from '../../custom/Search/Search';
import priceListService from "../../../api/pricelist";
import useUserInfo from '../../../hooks/useUserInfo';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ConfirmDialog from '../../custom/ConfirmDialog/ConfirmDialog';

import { basketState } from '../../../state/basketState';
import { updateBasketState } from '../../../state/updateBasketState';
import { useRecoilState } from "recoil";
import basketService from '../../../api/basket';
import DetailScreen from '../../custom/DetailScreen/DetailScreen';
import { compDetailUrl } from '../../../config';
import { fontGrid } from '@mui/material/styles/cssUtils';
import { useNavigate } from 'react-router-dom';
import ExcelImport from '../../custom/ExcelImport/ExcelImport';

function PriceList() {
    const config = require('../../../config');
    const { lang, l } = useI18n();
    const navigator = useNavigate();

    const [priceList, setPriceList] = React.useState();

    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);

    const [searchValue, setSearchValue] = React.useState('');
    const [checkedOrdered, setCheckedOrdered] = React.useState(false);
    const [orderCategories, setOrderCategories] = React.useState([]);

    const [_filters, _setFilters] = React.useState();
    const [filters, setFilters] = React.useState();
    const [uniqueFilters, setUniqueFilters] = React.useState();
    const [selectFilters, setSelectFilters] = React.useState({ level1: [], level2: [] });

    const { user } = useUserInfo();

    const [totals, setTotals] = React.useState({ totSum: 0, totWeight: 0, totVolume: 0, frrate: 0 });
    const [basketRecoil, setBasketRecoil] = useRecoilState(basketState);
    const [update, setUpdate] = useRecoilState(updateBasketState);

    const [pagePagination, setPagePagination] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(100);
    const [ownPagination, setOwnPagination] = React.useState({
        page: pagePagination,
        pageSize: pageSize,
        totalItems: 1,
        rowsPerPageOptions: [20, 50, 100, 200],
    });
    const [openDetail, setOpenDetail] = React.useState(false);
    const [detailUrl, setDetailUrl] = React.useState('');

    const [isGrouped, setIsGrouped] = React.useState(true);

    const getPriceList = async (prop) => {

        setPriceList([]);

        try {
            if (user) {

                const priceList = await priceListService.findAllByUserId(prop, lang);
                //const priceList = fakeData;
                // console.log('priceList :>> ', priceList);

                setOwnPagination({
                    page: priceList.currentPage,
                    pageSize: pageSize,
                    totalItems: priceList.totalItems,
                    totalPages: priceList.totalPages,
                    rowsPerPageOptions: [20, 50, 100, 200],
                })

                if (priceList) {
                    setPriceList(priceList.data);
                }
            }

        } catch (error) {
            console.error('Error getPriceList :>> ', error);
        }
    }

    const getFiltersArray = async () => {
        const uniqueFilters = await priceListService.getFiltersArrayByWebConf(lang);
        setUniqueFilters(uniqueFilters);
    };

    const getFilters = async () => {
        const filter = await priceListService.getFiltersByWebConf(lang);
        getFiltersArray();
        filter.level1 = filter?.level1.sort();
        _setFilters(filter);
        setFilters(filter);
    };

    const getOrderedByCategoryAndSumByCustCode = async () => {
        try {
            const orderByCategoryCum = await priceListService.getOrderedByCategoryAndSumByCustCode(lang);

            setOrderCategories(orderByCategoryCum.dataOrderedByCategories);
            setTotals({
                totSum: orderByCategoryCum.totsum,
                totWeight: Number(orderByCategoryCum.totweight)?.toFixed(5),
                totVolume: Number(orderByCategoryCum.totvolume)?.toFixed(5),
                frrate: orderByCategoryCum.frrate
            })
        }
        catch (error) {
            console.error('Error getOrderedByCategoryAndSumByCustCode :>> ', error);
        }
    };

    React.useEffect(() => {
        if (user) {
            getFilters();
            getOrderedByCategoryAndSumByCustCode();
        }
    }, [user, update]);

    const getPriceListByUser = () => {
        setIsGrouped(true);
        if (user && !checkedOrdered) {
            getPriceList({
                filters: selectFilters,
                search: searchValue,
                page: pagePagination || 1,
                pageSize: pageSize,
                showOrderedProd: false
            });
        }

        if (user && checkedOrdered) {
            getPriceList({
                filters: selectFilters,
                search: searchValue,
                page: pagePagination || 1,
                pageSize: pageSize,
                showOrderedProd: true
            });
        }
    }

    React.useEffect(() => {
        getPriceListByUser();
    }, [user, pagePagination, pageSize, selectFilters, checkedOrdered, update]);

    const columns = [
        { id: 'qtartcode', label: l('Code'), minWidth: 50, type: CellType.STRING, isDetail: false },
        { id: 'fname', label: l('Name'), minWidth: 200, type: CellType.PRODUCT_NAME },
        { id: 'fimg', label: l('Image'), minWidth: 80, type: CellType.IMG, align: 'center' },
        //{ id: 'finstock', label: l('Availability'), minWidth: 120, type: CellType.FINSTOCK, align: 'center' },
        { id: 'fprice1', label: l(config.price1Label) + (config.appCompno === '2' ? `,${config.currencySignPrice1}` : ''), minWidth: 100, type: CellType.PRISE_WITH_DISCOUNT, align: 'center' },
        { id: 'fprice2', label: l(config.price2Label) + (config.appCompno === '2' ? `,${config.currencySignPrice2}` : ''), minWidth: 80, type: CellType.STRING_WITH_CURRENCY, align: 'center' },
        { id: 'quant', label: l('Quantity'), minWidth: 80, type: CellType.EDITABLE_NUMBER },
        { id: 'itemsum', label: l('Sum'), minWidth: 80, type: CellType.PRODUCT_SUM },
    ];

    const debounceTimers = React.useRef({});

    const handelAction = (event, type, row) => {
        const { value } = event.target;

        switch (type) {
            case CellType.EDITABLE_NUMBER:
                const key = row.qtartcode;

                if (debounceTimers.current[key]) {
                    clearTimeout(debounceTimers.current[key]);
                }

                debounceTimers.current[key] = setTimeout(() => {
                    event.target.value = (value.toString() === '0' || value.toString() === '') ? '0' : value.toString().replace(/^0+/, '');

                    row.quant = value;
                    const discount = row.fdiscount || 0;

                    let pricewithoutDiscount = Math.round(row.fprice1 * row.quant * 100) / 100;
                    let priceWithDiscount = Math.round((pricewithoutDiscount - (pricewithoutDiscount * discount / 100)) * 100) / 100;
                    row.itemsum = priceWithDiscount;

                    row.sumfweight = Math.round(row.fweight * row.quant * 1000) / 1000;
                    row.sumfvolume = Math.round(row.fvolume * row.quant * 100000) / 100000;

                    const updatedTableData = priceList.map(item => {
                        if (item.qtartcode === row.qtartcode) {
                            return {
                                ...item,
                                quant: row.quant,
                                itemsum: row.itemsum
                            };
                        }
                        return item;
                    });

                    setPriceList(updatedTableData);

                    if (user) {
                        try {
                            const fetcData = async () => {
                                const basket = await basketService.updateBasket(row);
                                setBasketRecoil({ basket });
                                await getOrderedByCategoryAndSumByCustCode();
                            };

                            fetcData();
                        } catch (error) {
                            console.error('Error update Cart :>> ', error);
                        }
                    }

                    delete debounceTimers.current[key];
                }, 500); // Затримка 500 мс

                break;

            case CellType.PRODUCT_NAME:
                const url = compDetailUrl + row.finfopage;
                setOpenDetail(true);
                setDetailUrl(url);
                break;

            default:
                break;
        }
    };

    const hendleOrderProd = (e) => {
        const { checked } = e.target;

        if (checked) {

            if (user) {
                getPriceList({
                    filters: selectFilters,
                    search: searchValue,
                    page: 1,
                    pageSize: pageSize,
                    showOrderedProd: true
                });
            }

            setPagePagination(0);
        }

        setCheckedOrdered(checked);

    }

    const debounceRef = React.useRef(null);
    const handelSearch = (value) => {

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            if (user) {
                getPriceList({
                    filters: selectFilters,
                    search: value,
                    page: 1,
                    pageSize: pageSize,
                    showOrderedProd: checkedOrdered
                });
            }

        }, 1000); // Затримка у 300 мс

        setSearchValue(value);

        setPagePagination(0);
    }

    const updateFilters = () => {

        const newFiltersObj = {
            level1: [],
            level2: [],
            level3: []
        };

        const levelLength = Object.fromEntries(
            Object.entries(selectFilters).map(([key, value]) => [key, value.length])
        );

        const checkedLevelLength = Object.entries(levelLength).reduce(
            (acc, [key, length]) => {
                if (length > 0) {
                    acc.length += 1;
                    acc.levelKey = key;
                }
                return acc;
            },
            { length: 0, levelKey: '' }
        );

        Object.keys(selectFilters).forEach((level) => {
            const value = selectFilters[level];
            const otherLevels = Object.keys(selectFilters).filter((key) => key !== level);

            const levelArrays = otherLevels.map(() => []);

            if (value.length === 0 && otherLevels.every((lvl) => levelLength[lvl] === 0)) {
                otherLevels.forEach((lvl, index) => {
                    newFiltersObj[lvl] = _filters[lvl];
                    levelArrays[index] = _filters[lvl];
                });
                newFiltersObj[level] = _filters[level];
                return;
            }

            if (checkedLevelLength.length === 1 && checkedLevelLength.levelKey === level) {
                newFiltersObj[level] = _filters[level];
            }

            value.forEach((item) => {
                const newFilters = uniqueFilters.filter((uniqueItem) =>
                    uniqueItem[level] === item &&
                    otherLevels.every((lvl, idx) =>
                        selectFilters[lvl].length === 0 || selectFilters[lvl].includes(uniqueItem[lvl])
                    )
                );

                newFilters.forEach((filter) => {
                    otherLevels.forEach((lvl, idx) => {
                        if (!levelArrays[idx].includes(filter[lvl])) {
                            levelArrays[idx].push(filter[lvl]);
                        }
                    });
                });

                filters[level].forEach((filter) => {
                    if (!newFiltersObj[level].includes(filter)) {
                        newFiltersObj[level].push(filter);
                    }
                });

                otherLevels.forEach((lvl, idx) => {
                    levelArrays[idx].forEach((filter) => {
                        if (!newFiltersObj[lvl].includes(filter)) {
                            newFiltersObj[lvl].push(filter);
                        }
                    });

                    newFiltersObj[lvl] = newFiltersObj[lvl].sort();
                });
            });

            newFiltersObj[level] = newFiltersObj[level].sort();
        });

        setFilters(newFiltersObj);
    };

    const filtersByValue = (level, value, levels) => {
        selectFilters[level] = value;
        setSelectFilters({ ...selectFilters });

        const levelArrays = levels.map(() => []);

        if (value.length === 0) {
            updateFilters();
            setPagePagination(0);
            return;
        }

        const newFiltersObj = {
            level1: [],
            level2: [],
            level3: []
        };

        value.forEach((item) => {
            const newFilters = uniqueFilters.filter((uniqueItem) =>
                uniqueItem[level] === item
            );

            newFilters.forEach((filter) => {
                levels.forEach((lvl, index) => {
                    if (!levelArrays[index].includes(filter[lvl])) {
                        levelArrays[index].push(filter[lvl]);
                    }
                });
            });

            filters[level].forEach((filter) => {
                if (!newFiltersObj[level].includes(filter)) {
                    newFiltersObj[level].push(filter);
                    newFiltersObj[level] = newFiltersObj[level].sort();
                }
            });

            levels.forEach((lvl, index) => {
                levelArrays[index].forEach((filter) => {
                    if (!newFiltersObj[lvl].includes(filter)) {
                        newFiltersObj[lvl].push(filter);
                        newFiltersObj[lvl] = newFiltersObj[lvl].sort();
                    }
                });
            });
        });

        setFilters(newFiltersObj);
    };

    const handelFilterCategory = (e, value) => {

        filtersByValue('level1', value, ['level2', 'level3']);
        setPagePagination(0);
    }

    const handelFilterBrand = (e, value) => {

        filtersByValue('level2', value, ['level1', 'level3']);
        setPagePagination(0);
    }

    const handelFilterOther = (e, value) => {

        filtersByValue('level3', value, ['level1', 'level2']);
        setPagePagination(0);
    }

    const handleChangeRowsPerPage = (event) => {
        setPageSize(+event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        window.scrollTo(0, 0);
        setPagePagination(newPage);
    };

    const handleDelete = () => {
    
            const fetcData = async () => {
    
                try {
                    await basketService.deleteBasket();
                    clearBasket();
                } catch (error) {
                    console.error('Error deleteBasket >> ', error);
                }
            };
    
            fetcData();
    
            setOpenConfirmDialog(false)
        };

    const clearBasket = () => {
        const newBasket = {
            basket: {},
        };
        setBasketRecoil(newBasket);
        setTotals(t => ({...t, ...{ totSum: 0, totWeight: 0, totVolume: 0}}));
        getPriceListByUser();
    };
    return (
        <>
            <Box display="flex" justifyContent="space-between" margin={'10px 0'} >
                <Box display="flex" >
                    <Box width="300px">
                        <Typography component="h2" variant="h5">
                            {l('Price list')}
                        </Typography>
                    </Box>
                    <Box marginRight={1}>
                        <Box display='flex' alignItems={'center'}  sx={{ fontWeight: 'bold' }}>
                            {l('Order amount')}: <span style={{ color: 'green' }}>{totals.totSum}</span>{config.currencySignPrice1}
                            {config.appCompno === '1' ? (
                                /* <Tooltip title={l('Exchange rate') + `: ${totals.frrate} ₴`}>
                                    <Typography marginLeft={'4px'}>
                                        {`(~${Math.round(totals.frrate * totals.totSum)}₴)`}
                                    </Typography>
                                </Tooltip> */
                                null
                            ) : ''}
                        </Box>
                        <Box display="flex">
                            <Typography color="#dc3545" marginRight={1}>
                                {totals.totWeight} {l('Kg')}
                            </Typography>
                            <Typography color="#007bff">
                                {totals.totVolume} {l('m³')}
                            </Typography>
                        </Box>
                    </Box>
                </Box> 
                <Box style={{display:'flex', flexGrow: 1, flexDirection: 'row', gap: '10px'}}>
                    <Button onClick={() => {navigator('/basket')}} style={{display:'flex', flexGrow: 1}} variant='contained'>{l('OrderBay')}</Button>
                    <Button style={{display:'flex', flexGrow: 1}} variant='contained' color="error" onClick={() => setOpenConfirmDialog(true)} >{l('Clear')}</Button>
                </Box>
                <Search onChange={handelSearch} value={searchValue} />
            </Box>
            <Box display="flex">
                <Box className="shadow" sx={{ backgroundColor: 'white' }} width="320px" padding={1} marginRight={1} borderRadius="4px">
                    <Box display="flex" alignItems="center">
                        <FilterAltIcon />
                        {l('Filtration')}
                    </Box>
                    <Autocomplete
                        multiple
                        id="level1" //category
                        onChange={handelFilterCategory}
                        options={filters?.level1 || []}
                        getOptionLabel={(option) => option}
                        // defaultValue={[top100Films[0]]}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label={l("Category")}
                                placeholder=""
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        id="level2" //brand
                        onChange={handelFilterBrand}
                        options={filters?.level2 || []}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label={l("Brand")}
                                placeholder=""
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        id="level3" //other - size
                        onChange={handelFilterOther}
                        options={filters?.level3 || []}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label={l("Other")}
                                placeholder=""
                            />
                        )}
                    />
                    <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={hendleOrderProd} />} label={l('Show ordered products')} />
                    </FormGroup>
                    <Divider orientation="horizontal" />
                    <ExcelImport/>
                    {/* <Typography marginTop={1} fontWeight="bold">{l('Ordered by categories')}</Typography>
                    {orderCategories.map((item, index) => (
                        <Box key={index} display="flex" justifyContent="space-between">
                            <Typography>{item.level1}</Typography>
                            <Typography>{item.total}</Typography>
                        </Box>
                    ))} */}
                </Box>

                <Box width="100%">
                    <TableData
                        columns={columns}
                        rows={priceList}
                        cellBtnActionByType={handelAction}
                        isPriceList={true}
                        ownPagination={ownPagination}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        isGrouped={isGrouped}
                    />
                </Box>
            </Box>
            <DetailScreen isOpened={openDetail} setOpenDetail={setOpenDetail} detailUrl={detailUrl} />
            <ConfirmDialog
                            handleConfirm={handleDelete}
                            open={openConfirmDialog}
                            handleClose={() => setOpenConfirmDialog(false)}
                            title={`⚠️ ${l('Clear basket')}`}
                            contentText={`${l('Are you sure that you want to clear the basket, all products that were selected will be deleted')}!`}
                            denyButtonText={l('Cancel')}
                            confirmButtonText={l('Agree')}
                        />
        </>
    );
}

export default PriceList;